module.exports = __webpack_public_path__ + "static/media/case-lang-veirs.b23b8e16.jpg";